export default [{"url":"https://qweweretwe-0.api.invexerp.io","name":"Branch 1","port":"5023","isStore":true,"isHQ":true}]